import { Link, useNavigate, useParams } from 'react-router-dom';
import { DEFAULT_LOCAL_PATH } from '../../constents';

import { post } from '../Auths/AuthToken';
import { useEffect, useRef } from 'react';
import setUiMessage from '../../Utilities/Tostify';
import { useDispatch, useSelector } from 'react-redux';
import { setSeltSerchPat } from '../../redux/slices/patient/patientSlice';

function RecentChartList({ list, setOpenRecentCart, isOpen }) {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const navigate = useNavigate();
  const { patientId } = useParams();
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref?.current && !ref?.current.contains(event.target)) {
        setOpenRecentCart && setOpenRecentCart();
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [setOpenRecentCart, ref]);

  const handleRecentChartListUpdate = async (patId) => {
    if (patientId !== patId) {
      try {
        const response = await post(
          'api/patient/patient/saveRecentSearchInfo',
          {
            staffUserId: user.id,
            patientId: patId,
          }
        );
        if (response.status === 200) {
          setOpenRecentCart(false);
          dispatch(setSeltSerchPat(patId));
          navigate(`${DEFAULT_LOCAL_PATH}/patient/counNote/${patId}`);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    } else {
      setOpenRecentCart(false);
    }
  };
  if (!isOpen) {
    return null;
  }
  return (
    <div ref={ref} className="recnt-chart-contnr">
      <div style={{ padding: '5px 0', textAlign: 'right' }}>
        <span className="" onClick={() => setOpenRecentCart(false)}>
          X
        </span>
      </div>
      <ul className="rc-li-con">
        {list &&
          list.map((data, idx) => {
            return (
              <li
                key={idx}
                className={idx % 2 === 0 ? 'rc-pt-lst rc-pt-lst' : 'rc-pt-lst'}
              >
                <Link
                  // to={`${DEFAULT_LOCAL_PATH}/patient/${data?.patId}`}
                  onClick={() => handleRecentChartListUpdate(data?.patId)}
                >
                  <span className="rc-pt-nm">{`${data?.patName} [ID: ${data?.patChart}]`}</span>
                </Link>
                <span className="rc-pt-ifo">
                  {`${data?.patYearGen} DOB: ${data?.dob}`}
                </span>
                <span className="rc-pt-ifo">
                  Last visit: {data?.lastVisitStr}
                </span>
              </li>
            );
          })}
      </ul>
    </div>
  );
}

export default RecentChartList;
